import styles from './shared.module.css';

const SegmentedToggle = ({ options, value, onChange, ariaLabel }) => (
  <div className={styles.segmentedGroup} role="group" aria-label={ariaLabel}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        className={`${styles.segmentedButton} ${value === option.value ? styles.segmentedButtonActive : ''}`}
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default SegmentedToggle;
